import request from "@/utils/request";

const contactsUserApi = {
  page: "/admin/contacts/emp/page",
  add: "/admin/contacts/emp/add",
  edit: "/admin/contacts/emp/edit",
  delete: "/admin/contacts/emp/delete",
  selector: "/admin/contacts/emp/selector",
  resetPassword: "/admin/contacts/emp/resetPassword",
  changeAccountStatus: "/admin/contacts/emp/changeAccountStatus",
  updateAdminStatus: "/admin/contacts/emp/updateAdminStatus",
  updateIsAdminGroup: "/admin/contacts/emp/updateIsAdminGroup",
  empSelector: '/admin/contacts/emp/selector',
  contact: "/contacts/emp/contact",
  searchContact: "/contacts/emp/searchContact",
  totalNumber: "/contacts/emp/totalNumber",
  getLoginUserDetailInfo: "/contacts/emp/loginUserDetailInfo",
  updateLoginUserInfo: "/contacts/emp/updateLoginUserInfo",
  updatePassword: "/contacts/emp/updatePassword",
};

export function pageEmp(parameter) {
  return request({
    url: contactsUserApi.page,
    method: "get",
    params: parameter,
  });
}

export function addEmp(parameter) {
  return request({
    url: contactsUserApi.add,
    method: "post",
    data: parameter,
  });
}

export function editEmp(parameter) {
  return request({
    url: contactsUserApi.edit,
    method: "post",
    data: parameter,
  });
}

export function deleteEmp(parameter) {
  return request({
    url: contactsUserApi.delete,
    method: "post",
    data: parameter,
  });
}

/**
 * 获取通讯录
 */
export function contact() {
  return request({
    url: contactsUserApi.contact,
    method: "get",
  });
}

/**
 * 通讯录搜索教职工
 */
export function searchEmpContact(parameter) {
  return request({
    url: contactsUserApi.searchContact,
    method: "get",
    params: parameter,
  });
}

/**
 * 重置密码
 */
export function resetPassword(parameter) {
  return request({
    url: contactsUserApi.resetPassword,
    method: "get",
    params: parameter,
  });
}

/**
 * 修改用户状态
 */
export function changeAccountStatus(parameter) {
  return request({
    url: contactsUserApi.changeAccountStatus,
    method: "post",
    data: parameter,
  });
}

/**
 * 教职工总数
 */
export function empTotalNumber(parameter) {
  return request({
    url: contactsUserApi.totalNumber,
    method: "get",
    params: parameter,
  });
}

export function getLoginUserDetailInfo() {
  return request({
    url: contactsUserApi.getLoginUserDetailInfo,
    method: "get",
  });
}

export function updateLoginUserInfo(parameter) {
  return request({
    url: contactsUserApi.updateLoginUserInfo,
    method: "post",
    data: parameter,
  });
}

export function updatePassword(parameter) {
  return request({
    url: contactsUserApi.updatePassword,
    method: "post",
    data: parameter,
  });
}

export function updateAdminStatus(parameter) {
  return request({
    url: contactsUserApi.updateAdminStatus,
    method: "post",
    data: parameter,
  });
}

export function updateIsAdminGroup(parameter) {
  return request({
    url: contactsUserApi.updateIsAdminGroup,
    method: "post",
    data: parameter,
  });
}

export function empSelector(parameter) {
  return request({
    url: contactsUserApi.empSelector,
    method: "get",
    params: parameter,
  });
}
